var map = {
	"./asset-hyperlink.json": 47910,
	"./blockquote.json": 46800,
	"./document.json": 69778,
	"./embedded-asset-block.json": 21524,
	"./embedded-entry-block.json": 64872,
	"./embedded-entry-inline.json": 61458,
	"./embedded-resource-block.json": 31944,
	"./embedded-resource-inline.json": 66898,
	"./entry-hyperlink.json": 60150,
	"./heading-1.json": 39521,
	"./heading-2.json": 31956,
	"./heading-3.json": 2644,
	"./heading-4.json": 23274,
	"./heading-5.json": 80149,
	"./heading-6.json": 75288,
	"./hr.json": 69189,
	"./hyperlink.json": 15451,
	"./list-item.json": 59757,
	"./ordered-list.json": 90723,
	"./paragraph.json": 44927,
	"./resource-hyperlink.json": 78368,
	"./table-cell.json": 70524,
	"./table-header-cell.json": 34124,
	"./table-row.json": 76516,
	"./table.json": 4473,
	"./text.json": 44076,
	"./unordered-list.json": 31984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47688;